import { Validator } from '@vista-digital/validator';
export const defaultOccAnimationConfig = {
    enableAnimations: true
};
export const occAnimationConfigValidator = Validator.object({
    enableAnimations: Validator.boolean()
});
//# sourceMappingURL=animation.js.map